import PureRichText from '../../../common/PureRichText/PureRichText';
import styles from './ResultsCount.module.scss';
import PureImage from '../../../common/Image/PureImage';
import { sanitizeText } from '../../../../lib/utils/sanitizeText.utils';
import { useFiltersView } from '../../../../lib/context/FiltersViewContext';
import { CY_FILTERS } from '../../../../lib/constants/cypress';
import { SCALE } from '../../../common/Image/ImageScale';

export type SummaryResultsComponentProps = {
  total: number;
};

const ResultsCount = ({ total }: SummaryResultsComponentProps) => {
  const { summaryTemplateLabel, summaryNoResultTemplateLabel, summaryMessageIcon, from, to } = useFiltersView();
  const placeholdersPattern = /\{\{from\}\}|\{\{to\}\}|\{\{total\}\}/g;

  const resultsTemplate = sanitizeText(summaryTemplateLabel).replace(placeholdersPattern, word => {
    switch (word) {
      case '{{from}}':
        return `${from}`;
      case '{{to}}':
        return `${to}`;
      case '{{total}}':
        return `${total}`;
      default:
        return word;
    }
  });

  return (
    <div className={styles.mainContainer}>
      <PureImage src={summaryMessageIcon} className={styles.icon} scale={SCALE.ICON} />
      <PureRichText
        richtextClass={styles.textContainer}
        richtext={total > 0 ? resultsTemplate : summaryNoResultTemplateLabel}
        data-cy={CY_FILTERS.RESULTS_SUMMARY_TEXT}
      />
    </div>
  );
};

export default ResultsCount;
